import React, { ComponentProps } from 'react';
import { asView } from '../../../ViewFetcher';
import { Download } from '../../Download';
import { IFileItem } from '../../../../types/api/FileItem';
import { ISonURL } from '../../../../types/IUrl';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContentParagraph } from '../../ContentParagraph';
import { Dfn } from '../../Dfn/Dfn';
import { DfnModifier } from '../../Dfn/Dfn';

type ExternalContentEditDefaultProps = {
  iframe: ISonURL & { popUpUrl?: string };
  fileLinkItem?: IFileItem;
};

function ExternalContentEditDefault({ iframe, fileLinkItem }: ExternalContentEditDefaultProps) {
  const { t } = useSonTranslation('ExternalContent');

  if (!iframe) {
    return null;
  }

  if (fileLinkItem) {
    return (
      <div className="external-content">
        <Download {...fileLinkItem} />
      </div>
    );
  }

  return (
    <div className="external-content">
      <ContentParagraph>
        <Dfn modifier={DfnModifier.BOLD}>{t('externalContentUrl')}</Dfn>: {iframe.url}
      </ContentParagraph>
      {iframe?.popUpUrl && (
        <ContentParagraph>
          <Dfn modifier={DfnModifier.BOLD}>{t('externalContentPopUpUrl')}</Dfn>: {iframe.popUpUrl}
        </ContentParagraph>
      )}
    </div>
  );
}

export const ExternalContentEditDefaultView = asView(ExternalContentEditDefault);
export type ExternalContentEditDefaultView = ComponentProps<typeof ExternalContentEditDefaultView>;
